import React, { useContext, useEffect, useState } from 'react';
import { PageContainer, PageContent } from 'app/components/common';
import { BreadcrumbContext } from '../../breadcrumbs/BreadcrumbContext';
import './styles.less';
import Banner from '../common/Banner/MediaBanner';
import { FeatureFlag, useFeatureFlagValue } from '../../featureFlags';
import LearningList from '../common/learningList';
import { Spin } from 'antd';
import UserSummary from './UserSummary';
import { getString } from '@nackle/intl-tools';
import RoadMap from './RoadMap';
import { Navigation, Routes } from '../../navigation';
import { COMPONENT_LIST_TYPES, useComponentListsQuery } from '../../gql/hooks/queries/useComponentListQuery';

export const MyJourneyPage = ( props ) => {

    const { leaveCrumb } = useContext( BreadcrumbContext );   
    
    const videoUrl = useFeatureFlagValue( 'LXP.PAGE.HOME.BANNER.VIDEO' );

    const { data, loading } = useComponentListsQuery( COMPONENT_LIST_TYPES.HOMEPAGE );

    const [ curriculums, setCurriculums ] = useState( [] );
    const [ allData, setAllData ] = useState( [] );

    useEffect( () => {
        if ( loading ) {return;}

        if ( !data?.all?.length > 0 ) {
            Navigation.push( Routes.MyProgress.buildPath() );
            return;
        }

        leaveCrumb( props.key );

        setCurriculums( data.curriculums.sort( statusSorter ) );
        setAllData( data.all );

    }, [ loading, data ] );

    function statusSorter( a, b ) {
        const aVal = a.progress == 100 || [ 'COMPLETED', 'COMPLETED_REVISED' ].includes( a.status ) ? 1 : 0;
        const bVal = b.progress == 100 || [ 'COMPLETED', 'COMPLETED_REVISED' ].includes( b.status ) ? 1 : 0;
        return aVal - bVal;
    }

    return (
        <PageContent className="page-my-journey">           
           <PageContainer className="my-journey-banner-container">

                <Banner.Video title={ getString( 'myJourney.banner.title' ) } description={ getString( 'myJourney.banner.description' ) } videoUrl={ videoUrl } image={ '/images/banner-ai.jpg' } />

            
                <div className="page-content">
                    <UserSummary data={ allData } loading={ loading } />
                    
                    <FeatureFlag name={ 'LXP.HOMEPAGE.CURRICULUMS.GRID.ENABLED' } >
                        <FeaturedCurriculumGrid 
                            loading={ loading }
                            data={ curriculums } />
                    </FeatureFlag>

                    <RoadMap data={ allData } loading={ loading } />
                
                </div>

            </PageContainer>
        </PageContent>
    );
};



const FeaturedCurriculumGrid = ( { data, loading } ) => {
    
    const title = getString( 'myJourney.component.curriculums.title' )?.trim();
    const description = getString( 'myJourney.component.curriculums.description' )?.trim();

    return <div className='curriculum-list'>
        { ( title || description ) && 
            <div className="curriculum-text list-header">
                { title &&
                    <h2 className='front-page-header highlight text-no'>{ title }</h2>
                }

                { description &&
                    <span className='text-no subtitle'>{ description }</span>
                }
            </div>
        }
        { loading ? <Spin /> : 
            !data?.length > 0 ? getString( 'curriculumList.empty' ) :
            <LearningList 
                displayType={ 'card' }
                learningType={ 'curriculum' }
                isLoading={ loading }
                data={ data?.slice( 0, 12 ) } />
        }
    </div>;
};